import { Component, Input, OnInit } from '@angular/core';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { Dictionary } from 'src/app/util/to-dictionary';

@Component({
  selector: 'app-apg-beat-your-broker-complete',
  templateUrl: './apg-beat-your-broker-complete.component.html',
  styleUrls: ['./apg-beat-your-broker-complete.component.scss'],
})
export class ApgBeatYourBrokerCompleteComponent implements OnInit {

  @Input() quickQuote: QQQuestionnaireViewModel;  
  data: Dictionary<string> = {};
  
  constructor() { }

  ngOnInit() {
    this.data = this.quickQuote.answersObject;
  }

}
